import React from 'react'
import { useTranslation } from 'react-i18next';
import { Button, Col, Form, Modal } from 'react-bootstrap';
import { useCreateIndustryMutation } from '../../api/industryApiSlice';
import Icon from '../Icon';
import { FormGroup, Yup, useForm } from '../components';

const NewIndustryModal = ({show, onClose}) => {
  const { t } = useTranslation();
  const initialValues = {
    name: "",
  }
  const validationSchema = Yup.object().shape({
    name: Yup.string(),
  })
  const [createIndustry] = useCreateIndustryMutation();
  const { formData, setFormData, getInputProps, formProps, submitButtonProps } = useForm({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (data) => {
      createIndustry({...data}).unwrap().then(onClose)
    },
  });

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
        {t("new")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form {...formProps}>
          <Form.Row>
            <FormGroup input="text" as={Col} md={12} lg={12} {...getInputProps("name")} label={t('industries.form.name')}/>
          </Form.Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button key="submit" type="submit" variant="primary" {...submitButtonProps} >
          <Icon icon='save' text={t("save")}/>
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default NewIndustryModal;